export default [
  'float_balance',
  'micro_loan_fund',
  'micro_loan_interest',
  'micro_loan_insurance',
];
